// @ts-nocheck

import FunwooAPI from '@/swagger';
import { Flex, Spinner } from '@chakra-ui/react';
import { GetStaticPaths, GetStaticProps } from 'next';
import Script from 'next/script';

const Referral = () => {
  return (
    <>
      <Script
        id='line-sdk'
        onLoad={() => {
          (async () => {
            try {
              const pathArray = window.location.pathname.split('/');
              await liff.init({
                liffId: pathArray[pathArray.length - 1],
              });
              let match,
                pl = /\+/g, // Regex for replacing addition symbol with a space
                search = /([^&=]+)=?([^&]*)/g,
                decode = function (s) {
                  return decodeURIComponent(s.replace(pl, ' '));
                },
                query = window.location.search.substring(1);
              let urlParams = {};
              while ((match = search.exec(query))) urlParams[decode(match[1])] = decode(match[2]);
              if (!liff.isLoggedIn()) {
                await liff.login();
              }
              const profile = await liff.getProfile();
              await FunwooAPI.crm.createVisitor({
                id: profile.userId,
                displayName: profile.displayName,
                pictureUrl: profile.pictureUrl,
                ref: urlParams?.ref ?? undefined,
              });
            } catch (error) {
              console.log(error.code, error.message);
            } finally {
              liff.openWindow({ url: `https://line.me/R/ti/p/${process.env.NEXT_PUBLIC_LINE_OA_ID}` });
            }
          })();
        }}
        onError={() => {
          console.log('error');
        }}
        src='https://static.line-scdn.net/liff/edge/2/sdk.js'
      ></Script>
      <Flex w={'100%'} h={'100%'} justify={'center'} align={'center'}>
        <Spinner size='lg' emptyColor='gray.200' speed='.8s' thickness={'6px'} />
      </Flex>
    </>
  );
};
export const getStaticProps: GetStaticProps = async ({ params }) => {
  return {
    props: {
      liffId: params!.liffId,
    },
  };
};
export const getStaticPaths: GetStaticPaths = async () => {
  const { data } = await FunwooAPI.referralApplication.findAll();
  return {
    paths: data
      .filter((item) => item.type === 'line')
      .map((item) => {
        return {
          params: {
            liffId: item.id,
          },
        };
      }),
    fallback: true, // false or 'blocking'
  };
};
export default Referral;
